/** 13–19 digits in a row, optionally grouped by spaces/dashes — anywhere in the text. */
const CARD_NUMBER_LIKE = /(?:\d[ -]?){12,18}\d/;

/**
 * PCI guard for the search box: true when the text contains something card-number shaped.
 * Such a query is never matched, sent to an API, stored or logged.
 */
export function looksLikeCardNumber(text: string): boolean {
  return CARD_NUMBER_LIKE.test(text || '');
}
